import * as Enumerable from "linq";
import { MepYearOverYearEmissionResultItemModel } from "../../../../../../../../models/mep/mep-year-on-year.models";
import { LineChartHelper } from "../../../../common-vm/line-chart-helper";
import { ConditionalDecimalPlacesValueConverter } from "../../../../converters/conditional-decimal-places-value-converter";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
const am4core = await import("@amcharts/amcharts4/core");
const am4charts = await import("@amcharts/amcharts4/charts");
const am4themes_animated = (await import("@amcharts/amcharts4/themes/animated")).default;

export class MepYearOnYearComparisonChartViewModel {

    legendColors: { [id: string]: string; } = {};
    scientificNotationConverter: ConditionalDecimalPlacesValueConverter = new ConditionalDecimalPlacesValueConverter();
    getYearColorFunc: (year: number) => string;

    constructor(chartDivName: string, private items: MepYearOverYearEmissionResultItemModel[], getYearColorFunc: (year: number) => string,
        private configService: ConfigService) {
        this.getYearColorFunc = getYearColorFunc;
        this.initChart(chartDivName);
    }

    initChart(chartDiv: string) {
        if (!this.items)
            return;

        this.legendColors = {};
        // here we re-arrange the data to a model that looks like the below 
        /*
        [{
            month: "Jan",
            2020: 12123
            2021: 53453
        },
        {
            month: "Feb",
            2020: 543
            2021: 6796
        }
        ...and so on 
        ]
        */
        const dataForChart = Enumerable.from(this.items).groupBy(x => x.emissionMonth)
            .select(x => {
                const item: any = {};
                item.month = x.first().monthName.substring(0, 3);
                const yearsWithEmissions = x.groupBy(x => x.emissionYear).select(x => {
                    return {
                        year: x.first().emissionYear,
                        emissionsTotal: x.sum(y => y.emissionValueInTonnes),
                        calendarYear: x.first().calendarYear
                    }
                })
                yearsWithEmissions.forEach(yearValue => {
                    const yearValueString = yearValue.year.toString();
                    item[yearValueString] = this.scientificNotationConverter.toView(yearValue.emissionsTotal, null); //prop name would be 2021-jan example 
                    item[`${yearValueString}_calendarYear`] = yearValue.calendarYear
                });
                return item;
            });

        //Create chart instance 
        am4core.useTheme(am4themes_animated);
        am4core.addLicense(this.configService.config.settings.amChartsLicense);
        const chart = am4core.create(chartDiv, am4charts.XYChart);

        // Create category axes that will use the month property we created in dataForChart
        LineChartHelper.AddXCategoryAxis(chart, "month")

        LineChartHelper.AddYValueAxis(chart, null, "#828894", "#828894", 13, 0, "0", 0);

        //We want to draw a line for each Year and the dots would then be the months thus we create a line series for each one
        Enumerable.from(this.items).groupBy(x => x.emissionYear).forEach((year) => {
            //get a color from MEP Chart colors (ASSUMPTION: we should never have an issue with color since we should never have more than 3 series)
            const color = this.getYearColorFunc(year.key());
            LineChartHelper.AddCategorySeries(chart, color, "month", year.key(), `{categoryX} {${year.key()}_calendarYear} : {${year.key()}}`);
            this.legendColors[year.key()] = color;
        });

        chart.numberFormatter.numberFormat = "#";
        // chart.tooltip.background.fill = am4core.color("#F0F");

        //use XY cursor to highlight all points 
        chart.cursor = new am4charts.XYCursor();

        chart.data = dataForChart.toArray();
    }
}